// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Alex",
  middleName: "",
  lastName: "Wong",
  message: "Software Engineer",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/wongalex",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/alexswong/",
    },
  ],
};

// About Me SECTION
// If you want the About Me Section to show a profile picture you can fill the image Link either with:
//a) image in "editable-stuff" directory and use require("") to import here,
//      i.e: imageLink: require("../editable-stuff/alexwong.png")
//b) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: imageLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://drive.google.com/file/d/1QiDab2mkxMiECVyO4t9Y-pszE1H32ZZe/view?usp=sharing"
const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/profilepicscaled.jpg"),
  imageSize: 375,
  message:
      "Hey there! My name is Alex Wong and I am currently a Software Engineer at Amazon Robotics. I am passionate about software engineering and how we can make the world better through technology!",
  resume: "https://drive.google.com/file/d/1QiDab2mkxMiECVyO4t9Y-pszE1H32ZZe/view?usp=sharing",
};

// Experience SECTION
const experience = {
  show: true,
  heading: "Experience",
  data: [
    {
      role: 'Software Development Engineer',
      company: 'Amazon Robotics',
      companyLogo: require('../assets/images/amazonrobotics.png'),
      date: 'September 2022 - Present',
    },
    {
      role: 'Teaching Assistant',
      company: 'Columbia University',
      companyLogo: require('../assets/images/columbia.png'),
      date: 'September 2017 - June 2018',
    }
  ]
}

// Education SECTION
const education = {
  show: true,
  heading: "Education",
  data: [
    {
      school: 'Harvard University',
      degree: 'Master of Liberal Arts in Digital Media Design',
      schoolLogo: require('../assets/images/harvard.png'),
      graduationDate: 'May 2022',
    },
    {
      school: 'Columbia University',
      degree: 'Master of Science in Computer Science\n Machine Learning Track',
      schoolLogo: require('../assets/images/columbia.png'),
      graduationDate: 'May 2019',
    },
    {
      school: 'University of Washington',
      degree: 'Bachelor of Science in Computer Science and Software Engineering',
      schoolLogo: require('../assets/images/uwashington.png'),
      graduationDate: 'August 2015',
    },
  ]
}

// Projects SECTION
// Setting up reposLength will automatically fetch that number of most recently updated projects.
// Set this field to 0 to show no repos or if you plan to show specific repos.
//      i.e: reposLength: 0,
// If you want to display specific projects, add the repository names:
//      i.e specificRepos: ["repository-1", "repo-2"],
const repos = {
  show: true,
  heading: "Projects",
  gitHubUsername: "wongalex",
  reposLength: 0,
  specificRepos: ["ib-algorithm-grade-bias"]
};

// Skills SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "TypeScript", value: 95 },
    { name: "JavaScript", value: 95 },
    { name: "HTML/CSS", value: 90 },
    { name: "Java", value: 90 },
    { name: "SQL", value: 85 },
    { name: "LaTeX", value: 75 },
    { name: "Git", value: 95 },
    { name: "React", value: 95 },
    { name: "Unix/Linux", value: 85 },
    { name: "AWS", value: 90 },
    { name: "Jest", value: 80 },
    { name: "Node.js", value: 90 },
  ],
  softSkills: [
    { name: "Customer Focused", value: 100 },
    { name: "Goal Oriented", value: 95 },
    { name: "Collaboration", value: 95 },
    { name: "Positivity", value: 100 },
    { name: "Project Management", value: 95 },
    { name: "Adaptability", value: 95 },
    { name: "Problem Solving", value: 100 },
    { name: "Empathy", value: 95 },
    { name: "Organization", value: 90 },
    { name: "Creativity", value: 90 },
  ],
};

// Get In Touch SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
      "If you want to say hi, I am always up for a chat! Please feel free to email me at:",
  email: "alex.wong@columbia.edu",
};

export { navBar, mainBody, about, experience, education, repos, skills, getInTouch };